export const HSK_LEVELS_TO_BG_COLORS: Record<number, string> = {
  1: "bg-yellow-600",
  2: "bg-cyan-700",
  3: "bg-orange-500",
  4: "bg-indigo-700",
  5: "bg-violet-700",
};

export const HSK_LEVELS_TO_TEXT_COLORS: Record<number, string> = {
  1: "text-green-500",
  2: "text-green-400",
  3: "text-green-300",
  4: "text-green-200",
  5: "text-green-100",
};

export const SKILL_LEVELS_TO_BG_COLORS: Record<number, string> = {
  1: "bg-red-500",
  2: "bg-orange-500",
  3: "bg-yellow-600",
  4: "bg-black",
};

export const SKILL_LEVELS_TO_TEXT_COLORS: Record<number, string> = {
  1: "text-red-500",
  2: "text-orange-500",
  3: "text-yellow-600",
  4: "text-black",
};

export const SKILL_LEVELS_TO_DESCRIPTIONS: Record<number, string> = {
  1: "New",
  2: "Learning",
  3: "Familiar",
  4: "Mastered",
};
